import styled, { css } from 'styled-components';
import { Flex } from 'component/base/Grid';
import BaseAlert from 'component/base/Alert';

interface IContainer {
  withStepper?: boolean;
}

export const Container = styled(Flex)<IContainer>`
  padding: 0 10px;

  @media only screen and (max-width: 1050px) {
    padding-top: 0;
  }

  ${(props) =>
    props.withStepper &&
    css`
      @media only screen and (max-width: 1050px) {
        padding-top: 75px;
      }
    `}
`;

Container.defaultProps = {
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
};

export const Header = styled(Flex)`
  background-color: ${(props) => props.theme.colors.white};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  min-height: 75px;
  min-width: 350px;
`;

Header.defaultProps = {
  width: 1,
  py: '15px',
  justifyContent: 'center',
  flexDirection: 'column',
};

export const Content = styled(Flex)`
  margin: 0 auto;
  z-index: 1;
`;

Content.defaultProps = {
  width: 1,
  px: 2,
  alignItems: 'center',
  flexDirection: 'row',
};

export const Title = styled.h1`
  text-align: center;
  font-family: ClearfaceStd;
  font-weight: bold;
  font-size: 36px;
  color: ${(props) => props.theme.colors.darkBlue};
  margin-top: 120px;
`;

export const SignUp = styled('div')`
  width: 450px;
  & > * {
    margin-bottom: 24px;
    width: 100%;
  }

  & > p {
    color: ${(props) => props.theme.colors.darkBlue};
    font-weight: 600;
    text-align: center;

    &:last-of-type {
      margin-bottom: 40px;
    }
  }

  & > *:first-child {
    margin-bottom: 12px;
  }
`;

export const Alert = styled(BaseAlert)`
  line-height: 1.5;
`;
